import { createLucideIcon } from "lucide-react";

export const AGENT_HEX_DOT_RADIUS = 1.4;

// The Agent mark from Figma, scaled 1.4x about the centre off its 16px export
// grid so it sits on the ~20 unit grid the stock Lucide nav icons use. The ring
// runs clockwise from the top, then the centre.
export const AGENT_HEX_DOTS = [
  { key: "hex-n", cx: 12, cy: 3.6 },
  { key: "hex-ne", cx: 19, cy: 7.8 },
  { key: "hex-se", cx: 19, cy: 16.2 },
  { key: "hex-s", cx: 12, cy: 20.4 },
  { key: "hex-sw", cx: 5, cy: 16.2 },
  { key: "hex-nw", cx: 5, cy: 7.8 },
  { key: "hex-c", cx: 12, cy: 12 },
] as const;

export const AgentHexIcon = createLucideIcon(
  "AgentHex",
  AGENT_HEX_DOTS.map(({ key, cx, cy }) => [
    "circle",
    {
      cx: String(cx),
      cy: String(cy),
      r: String(AGENT_HEX_DOT_RADIUS),
      fill: "currentColor",
      stroke: "none",
      key,
    },
  ])
);
